<template>
  <div class="appointDiv">
    <div style="position: fixed;width: 100vw;background: #f4f5f6;z-index: 99;">
      <div class="top-cont">
        <van-tabs
          v-model="active"
          style="flex: 1;"
          @click="clickTimeTab"
          :class="timeRange.length > 0 ? 'hideTabActive' : ''"
        >
          <van-tab title="昨天" name="0"> </van-tab>
          <van-tab title="今天" name="1"> </van-tab>
          <van-tab title="明天" name="2"> </van-tab>
        </van-tabs>
        <div class="time" @click="showCalendar = true">
          <div
            v-if="timeRange.length === 0"
            style="display: flex;align-items: inherit;"
          >
            <van-icon name="clock-o" />选择指定日期
          </div>
          <div v-else>{{ timeRange.join("至") }}</div>
        </div>
      </div>
      <van-calendar
        id="appointListCal"
        v-model="showCalendar"
        color="#009967"
        type="range"
        @confirm="onConfirm"
        :show-confirm="false"
        :show-title="false"
        row-height="58"
        :round="false"
        position="right"
        :allow-same-day="true"
        :formatter="formatter"
        :min-date="minDate"
        :max-date="maxDate"
      >
        <template slot="footer">
          <div class="calendar-cont">
            <div style="flex: 1;" @click="setTime(0)">最近一周</div>
            <div style="flex: 1;" @click="setTime(1)">最近一个月</div>
            <div style="flex: 1;" @click="setTime(2)">最近一年</div>
          </div>
        </template>
      </van-calendar>
      <div>
        <van-search
          v-model="params.keyword"
          @search="searchList"
          placeholder="输入关键字搜索"
          @clear="clearSearchBar"
          input-align="left"
        />
      </div>
    </div>
    <div style="height: 91px;background-color: #f4f5f6;"></div>

    <div class="mid-cont" v-for="(item, index) in listData" :key="index">
      <div>
        <div class="title-left">
          {{ item.license_plate }}
        </div>
        <span style="color: rgba(0,0,0,0.80);line-height: 16px;">
          {{ item.company_name }}
        </span>
        <!-- <van-icon name="edit" class="title-icon" /> -->
        <div
          class="title-btn"
          v-if="item.state"
          :style="`background: ${stateColor[item.state]}`"
        >
          {{ stateOption[item.state] }}
        </div>
      </div>
      <div style="display: flex;width: 100%;">
        <div class="mid-cont-text" v-if="item.business">
          <span class="colorB2">预约类型：</span
          ><span class="colorOrange">应急预约</span><br />
          <span class="colorB2">预约业务：</span>{{ item.business.name }}<br />
          <span class="colorB2">预约时间：</span
          >{{ formatBookingTime(item.booking_time.booking_day) }}
          {{ item.booking_time.begin_time }}-{{ item.booking_time.end_time }}
          <br />
          <span class="colorB2">车辆类型：</span
          >{{
            item.vehicle_type === 0
              ? "--"
              : vehicleColumns[item.vehicle_type - 1]
          }}
          <br />
          <span class="colorB2">司机姓名：</span>{{ item.name }}<br />
          <span class="colorB2">联系方式：</span>{{ item.contact }}<br />
          <span class="colorB2">身份证号：</span>{{ item.id_card }}<br />
        </div>
        <div
          class="mid-cont-icon"
          v-if="
            (Number(item.state) === 1 ||
              Number(item.state) === 2 ||
              Number(item.state) === 3 ||
              Number(item.state) === 5) &&
              ((privilegeConfig.keys &&
                privilegeConfig.keys.indexOf('c-car-apply-fast-mgr') >= 0) ||
                dirverOrCoopUnit)
          "
        >
          <div @click="edit(item)">
            <van-icon name="edit" class="title-icon" />
          </div>
        </div>
      </div>
      <div
        class="mid-cont-more"
        @click="
          $router.push({
            path: '/rhwxEmergeAppointDetail',
            query: {
              info_id: item.info_id,
              id: item.id,
              pageType: 'list',
              time1: params.begin_time,
              time2: params.end_time,
              keyword: params.keyword
            }
          })
        "
      >
        查看更多<van-icon name="arrow" />
      </div>
    </div>
    <Empty v-if="listData.length == 0" style="margin-top: 60px;"></Empty>

    <div style="height: 86px;background-color: #f4f5f6;"></div>
    <div
      class="footer-cont"
      v-if="
        (privilegeConfig.keys &&
          privilegeConfig.keys.indexOf('c-car-apply-mine-mgr') >= 0) ||
          dirverOrCoopUnit
      "
    >
      <van-button type="primary" block class="btnStyle1" @click="addAppoint"
        >添加应急预约</van-button
      >
    </div>
  </div>
</template>
<script>
import moment from "moment";
import Empty from "@/components/tips/Empty.vue";
import privilegeMixin from "@/mixins/rh/privilegeMixin.js";

export default {
  data() {
    return {
      page: 1,
      pageSize: 999999,
      active: "1",
      showCalendar: false,
      timeRange: [],
      searchValue: "",
      minDate: new Date(moment().year() - 5, 0, 1),
      maxDate: new Date(moment().year() + 10, 0, 1),
      params: {
        begin_time: "",
        end_time: "",
        keyword: ""
      },
      loadEnd: false,
      listData: [],
      loading: false,
      vehicleColumns: ["平板车", "货柜车", "槽罐车", "其他", "高栏车"],
      stateOption: [
        "",
        "未报到",
        "已报到",
        "报到失效",
        "办理中",
        "已挂起",
        "已失效",
        "已关闭",
        "已完成",
        "已拒绝"
      ],
      stateColor: [
        "",
        "#B08931",
        "#00C8D2",
        "#666666",
        "#4F86F6",
        "#F5A623",
        "#666666",
        "#EC3F67",
        "#008B5E",
        "#EC3F67"
      ]
    };
  },
  mixins: [privilegeMixin],
  activated() {
    this.getList();
  },
  mounted() {
    this.params.begin_time = moment()
      .startOf("day")
      .format("YYYYMMDD");
    this.params.end_time = moment()
      .startOf("day")
      .format("YYYYMMDD");
    // 如果路由上时间不为空（保持搜索条件）
    if (this.time1) {
      let yesterday = moment()
        .subtract(1, "days")
        .format("YYYYMMDD");
      let today = moment()
        .startOf("day")
        .format("YYYYMMDD");
      let tomorrow = moment()
        .add(1, "days")
        .format("YYYYMMDD");
      this.params.begin_time = this.time1;
      this.params.end_time = this.time2;
      if (
        String(yesterday) === this.time1 &&
        String(yesterday) === this.time2
      ) {
        this.active = "0";
      } else if (String(today) === this.time1 && String(today) === this.time2) {
        this.active = "1";
      } else if (
        String(tomorrow) === this.time1 &&
        String(tomorrow) === this.time2
      ) {
        this.active = "2";
      } else {
        let str1 = this.params.begin_time;
        this.timeRange.push(
          `${str1.substring(0, 4)}/${str1.substring(4, 6)}/${str1.substring(
            6,
            8
          )}`
        );
        let str2 = this.params.end_time;
        this.timeRange.push(
          `${str2.substring(0, 4)}/${str2.substring(4, 6)}/${str2.substring(
            6,
            8
          )}`
        );
      }
    }
    if (this.keyword) {
      this.params.keyword = this.keyword;
    }
    this.getList();
    // localStorage.removeItem("appointEmergeModify");
  },
  components: {
    Empty
  },
  methods: {
    clickTimeTab(label) {
      this.active = label;
      this.timeRange = [];
      // 0 昨天 1 今天 2 明天
      this.page = 1;
      if (Number(label) === 0) {
        this.params.begin_time = moment()
          .subtract(1, "days")
          .format("YYYYMMDD");
        this.params.end_time = moment()
          .subtract(1, "days")
          .format("YYYYMMDD");
      } else if (Number(label) === 1) {
        this.params.begin_time = moment()
          .startOf("day")
          .format("YYYYMMDD");
        this.params.end_time = moment()
          .startOf("day")
          .format("YYYYMMDD");
      } else {
        this.params.begin_time = moment()
          .add(1, "days")
          .format("YYYYMMDD");
        this.params.end_time = moment()
          .add(1, "days")
          .format("YYYYMMDD");
      }
      this.timeRange = [];
      this.getList();
    },

    onConfirm(val) {
      console.log(val);
      this.timeRange = [];
      this.timeRange.push(moment(val[0]).format("YYYY/MM/DD"));
      this.timeRange.push(moment(val[1]).format("YYYY/MM/DD"));
      this.showCalendar = false;
      this.params.begin_time = moment(val[0])
        .startOf("day")
        .format("YYYYMMDD");
      this.params.end_time = moment(val[1])
        .startOf("day")
        .format("YYYYMMDD");
      this.getList();
    },

    // 关键字查询
    searchList() {
      this.page = 1;
      this.getList();
    },

    // 清空搜索框
    clearSearchBar() {
      this.page = 1;
      this.getList();
    },

    // 格式化日历显示
    formatter(day) {
      if (day.type === "start") {
        day.bottomInfo = "";
      } else if (day.type === "end") {
        day.bottomInfo = "";
      } else {
        day.bottomInfo = "";
      }
      return day;
    },

    // 快捷选择日期
    setTime(tag) {
      this.timeRange = [];
      let end = new Date();
      let start = new Date();
      if (tag === 0) {
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
      } else if (tag === 1) {
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      } else if (tag === 2) {
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
      }
      this.timeRange.push(moment(start).format("YYYY/MM/DD"));
      this.timeRange.push(moment(end).format("YYYY/MM/DD"));
      this.params.begin_time = moment(start).format("YYYYMMDD");
      this.params.end_time = moment(end).format("YYYYMMDD");
      this.showCalendar = false;
      this.getList();
    },

    // 格式化预约时间
    formatBookingTime(str) {
      let str1 = String(str);
      if (moment().year() === Number(str1.substring(0, 4))) {
        return `${str1.substring(4, 6)}月${str1.substring(6, 8)}日`;
      } else {
        return `${str1.substring(0, 4)}年
          ${str1.substring(4, 6)}月
          ${str1.substring(6, 8)}日`;
      }
    },

    // 获取列表
    async getList() {
      let data = {
        begin_time: this.params.begin_time,
        end_time: this.params.end_time,
        keyword: this.params.keyword,
        page_size: this.pageSize,
        page: this.page
      };
      await this.$common
        .http({
          url: "/api/queue/emergency/query_my_booking",
          data: data
        })
        .then(res => {
          this.listData = res.data.data.data;
        });
    },

    loadNext() {
      if (!this.loading) {
        this.getList();
      }
    },

    // 编辑
    edit(item) {
      this.$router.push({
        path: "rhwxEmergeAppointModify/0",
        query: {
          id: item.id,
          info_id: item.info_id,
          type: "edit",
          pageType: "list",
          time1: this.params.begin_time,
          time2: this.params.end_time,
          keyword: this.params.keyword
        }
      });
    },

    // 添加预约
    addAppoint() {
      this.$common
        .http({
          url: "/api/queue/emergency/query_draft_booking"
        })
        .then(res => {
          if (res.data.data.length > 0) {
            this.$router.push({
              path: "/rhwxEmergeAppointAdd",
              query: {
                pageType: "list",
                time1: this.params.begin_time,
                time2: this.params.end_time,
                keyword: this.params.keyword
              }
            });
          } else {
            this.$router.push({
              path: "/rhwxEmergeAppointModify/0",
              query: {
                type: "add",
                pageType: "list",
                time1: this.params.begin_time,
                time2: this.params.end_time,
                keyword: this.params.keyword
              }
            });
          }
        });
    }
  },
  created() {},
  computed: {
    time1() {
      return this.$route.query.time1;
    },
    time2() {
      return this.$route.query.time2;
    },
    keyword() {
      return this.$route.query.keyword;
    }
  }
};
</script>
<style lang="less" scoped>
@import "../assets/css/common";
.appointDiv {
  min-height: calc(100vh - 1px);
  background: #f4f5f6;
  .top-cont {
    display: flex;
    background: #fff;
    .time {
      flex: 1;
      font-size: 12px;
      line-height: 45px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #9b9b9b;
      height: 25px;
      margin-top: 9px;
      background: #f4f5f6;
      margin: 9px 15px 0px 11px;
    }
  }
  .mid-cont {
    background: #fff;
    padding: 16px 0px 16px 16px;
    font-size: 16px;
    margin-bottom: 10px;
    .title-left {
      display: inline-block;
      background: #e5f3ee;
      padding: 5px 7px;
      color: #008b5e;
      margin-right: 14px;
      border-radius: 2px;
    }
    .title-icon {
      float: right;
      font-size: 24px;
      color: #9b9b9b;
      top: 6px;
      right: 5px;
    }
    .title-btn {
      display: inline-block;
      color: #fff;
      padding: 6px 11px;
      border-radius: 2px;
      float: right;
      margin-right: 16px;
    }
    &-text {
      line-height: 30px;
      margin-top: 14px;
      width: 90%;
    }
    &-icon {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 20px 0px 9px;
    }
    &-more {
      margin-top: 13px;
      font-size: 14px;
      color: #b2b2b2;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .colorB2 {
    color: #b2b2b2;
  }
  .calendar-cont {
    height: 36px;
    font-size: 14px;
    display: flex;
    text-align: center;
    align-items: center;
    justify-content: center;
    color: #009967;
    background: #f7f7f7;
    box-shadow: 0px 2px 20px rgba(125, 126, 128, 0.16);
  }
}
</style>
<style lang="less">
.appointDiv {
  .hideTabActive {
    .van-tabs__line {
      background-color: #fff !important;
    }
    .van-tab--active {
      color: #b2b2b2 !important;
    }
  }
  .van-tab {
    font-size: 16px;
  }
  .van-search {
    padding: 10px 17px;
  }
  .van-button--round {
    border-radius: 4px;
  }
  .van-search {
    background-color: inherit;
  }
  .van-search__content {
    background-color: #fff;
  }
  .van-search .van-cell {
    padding: 1px 8px 1px 0;
    font-size: 13px;
  }
  #appointListCal .van-calendar__popup.van-popup--left,
  .van-calendar__popup.van-popup--right {
    height: 460px;
    margin: 0px 30px !important;
  }
  #appointListCal .van-calendar__footer {
    padding: 0px;
  }
}
</style>
